import { render, staticRenderFns } from "./AlertasPantalla.vue?vue&type=template&id=5b574509&scoped=true&"
import script from "./AlertasPantalla.vue?vue&type=script&lang=ts&"
export * from "./AlertasPantalla.vue?vue&type=script&lang=ts&"
import style0 from "./AlertasPantalla.vue?vue&type=style&index=0&id=5b574509&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b574509",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5b574509', component.options)
    } else {
      api.reload('5b574509', component.options)
    }
    module.hot.accept("./AlertasPantalla.vue?vue&type=template&id=5b574509&scoped=true&", function () {
      api.rerender('5b574509', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Telemetria/FugaCombustible/AlertasPantalla.vue"
export default component.exports